import { getAffiliateId } from "@/lib/api/fetchEndpoint";
import { session as sessionStore } from "@/store";
import { getConfigValue } from "@rumble-it/common-lib/src/config";

/**
 * Server Action: Delete an entity by its ID.
 * @param {Object} props
 * @param {string} props.entityType - The type of entity to delete. Keep it plural, e.g. "companies", "dossiers", etc.
 * @param {string} props.id - The ID of the entity to delete.
 */
export async function deleteEntityById({
  entityType = null,
  id = null,
  redirectTo = null,
  includeAffiliatePathPrefix = true,
}) {
  if (!entityType || !id) {
    throw new Error("entityType and id are required to delete an entity");
  }

  const API_URL = getConfigValue("apiUrl");

  const session = await sessionStore.get();

  if (!session || !(session as any).accessToken) {
    throw new Error("User is not authenticated");
  }

  const bearerToken = `Bearer ${(session as any).accessToken}`;

  const affiliateId = await getAffiliateId(session as any);

  const affiliatePathPrefix =
    affiliateId && includeAffiliatePathPrefix === true
      ? `/affiliates/${affiliateId}`
      : "";

  const endpoint = `${API_URL}${affiliatePathPrefix}/${entityType}/${id}`;

  const response = await fetch(endpoint, {
    method: "DELETE",
    headers: {
      Authorization: bearerToken,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to delete ${entityType} with id ${id}`);
  }

  // Redirect to the entity list page after deletion, or to the specified path if provided
  const redirectionPath = redirectTo || `/${entityType}`;

  // revalidatePath(redirectionPath); // Revalidate the entity list page after deletion
  window.location.href = redirectionPath; // Redirect to the entity list page after deletion
}
